import { render, staticRenderFns } from "./welfareMobile.vue?vue&type=template&id=72489892&scoped=true&"
import script from "./welfareMobile.vue?vue&type=script&lang=js&"
export * from "./welfareMobile.vue?vue&type=script&lang=js&"
import style0 from "./welfareMobile.vue?vue&type=style&index=0&id=72489892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72489892",
  null
  
)

export default component.exports